import { Form, Upload, Typography } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import { Scan } from "lucide-react";

const { Title } = Typography;
const { Dragger } = Upload;

export default function StepImaging({ imagingFiles = [], onUploadField }) {
  const imagingFileList =
    (imagingFiles || []).map((file, index) => ({
      uid: `img-${index}`,
      name: file.name,
      status: "done",
      originFileObj: file,
    })) || [];
  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
          <Scan className="w-6 h-6 text-[#0B7BC1]" />
        </div>
        <Title level={4} style={{ margin: 0 }}>
          Imaging
        </Title>
      </div>

      <Form.Item label="Upload Imaging Reports (X-ray, CT, MRI, Echo, ECG, etc.)">
        <Dragger
          multiple
          accept="image/*,.pdf,.dcm"
          beforeUpload={() => false}
          fileList={imagingFileList}
          onChange={onUploadField("imagingFiles")}
        >
          <div className="flex flex-col justify-center items-center px-2">

            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text text-center">
              Click or drag imaging files to this area to upload
            </p>
            <p className="ant-upload-hint text-center">
              Supports: X-ray, CT, MRI, Echo, ECG, and other imaging formats.
            </p>
          </div>

        </Dragger>
      </Form.Item>
    </div>
  );
}

